<template>
  <div class="active-detail">
    <div class="register">
      <div class="content">
        <div class="user-info">
          <h5>个人登记信息</h5>
          <p>
            <input
              v-model="params.realName"
              class="inp-name"
              type="text"
              placeholder="姓名"
            />
            <input
              v-model="params.phone"
              class="inp-phone"
              type="text"
              placeholder="请输入手机号"
            />
          </p>
          <p>
            <input
              v-model="params.cardId"
              class="id-number"
              type="text"
              placeholder="身份证号"
            />
          </p>
          <div class="enroll">
            <span>报名费用：¥{{ detailObj.price || 0 }}</span>
            <div class="btn" @click="handleClickRegister">我要报名</div>
          </div>
        </div>
        <div class="open-time">
          <h5>开放时间</h5>
          <p>活动时间</p>
          <p>{{ detailObj.startDate }} 至 {{ detailObj.stopDate }}</p>
          <p>主办方：</p>
          <p>{{ detailObj.sponsor || "暂无" }}</p>
          <p>活动简介：</p>
          <p>{{ detailObj.summary || "暂无简介" }}</p>

          <h5>场地</h5>
          <p>{{ detailObj.site || "未知" }}</p>
          <p>地址：{{ detailObj.address || "未知" }}</p>
          <p>{{ detailObj.startDate }} - {{ detailObj.stopDate }}</p>
        </div>
      </div>
    </div>
    <section>
      <article>
        <h4>{{ detailObj.activityName }}</h4>
        <span>{{ detailObj.releaseDate }}</span>
        <div v-html="detailObj.content"></div>
        <div class="article-time">{{ detailObj.releaseDate }}</div>
      </article>
      <aside>
        <div v-if="typeList.hot" @click="artActivityDetailFunc(typeList.hot.id)">
          <h4>热门活动</h4>
          <img :src="typeList.hot.image" alt="" />
          <p>{{ typeList.hot.activityName }}</p>
        </div>
        <div v-if="typeList.news" @click="artActivityDetailFunc(typeList.news.id)">
          <h4>最新活动</h4>
          <img :src="typeList.news.image" alt="" />
          <p>{{ typeList.news.activityName }}</p>
        </div>
        <div
          v-if="typeList.related"
          @click="artActivityDetailFunc(typeList.related.id)"
        >
          <h4>相关活动</h4>
          <img :src="typeList.related.image" alt="" />
          <p>{{ typeList.related.activityName }}</p>
        </div>
      </aside>
    </section>
    <div class="recommendation-list">
      <h4>推荐</h4>
      <div class="reco-box">
        <div
          v-for="item in recommendList"
          :key="item.id"
          class="reco-box-item"
          @click="artActivityDetailFunc(item.id)"
        >
          <img :src="item.image" />
          <p>{{ item.activityName }}</p>
          <span>¥{{ item.price || 0 }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  artActivityDetail,
  artActivityRecommendList,
  artActivityTypeList,
} from "@/api/NewInfo";

export default {
  name: "ActiveDetail",
  data() {
    return {
      query: {},
      detailObj: {},
      typeList: {},
      recommendList: [],
      params: {
        cardId: "",
        phone: "",
        realName: "",
      },
    };
  },
  mounted() {
    this.query = this.$route.query;
    this.artActivityDetailFunc(this.query.id);
    this.artActivityRecommendListFunc();
    this.artActivityTypeListFunc();
  },
  methods: {
    handleClickRegister() {
      if (!this.detailObj.id) {
        this.$message.warning("当前活动暂未开放报名入口");
        return;
      }
      this.$router.push(`/ContestApply/${this.detailObj.id}`);
    },
    artActivityDetailFunc(id) {
      artActivityDetail(id)
        .then((res) => {
          this.detailObj = res.data || {};
          document.body.scrollTop = document.documentElement.scrollTop = 0;
        })
        .catch(() => {
          this.detailObj = {};
        });
    },
    artActivityRecommendListFunc() {
      artActivityRecommendList({ limit: 6 })
        .then((res) => {
          this.recommendList = res.data || [];
        })
        .catch(() => {
          this.recommendList = [];
        });
    },
    artActivityTypeListFunc() {
      artActivityTypeList()
        .then((res) => {
          this.typeList = res.data || {};
        })
        .catch(() => {
          this.typeList = {};
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.active-detail {
  .register {
    height: 584px;
    background: #2d3f51;
    .content {
      width: 1040px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .user-info {
        padding-top: 152px;
        width: 362px;
        h5 {
          margin-bottom: 20px;
          font-size: 26px;
          color: #fff;
          text-align: center;
        }
        p {
          display: flex;
          justify-content: space-between;
          margin-bottom: 32px;
        }
        input {
          box-sizing: border-box;
          padding: 0 12px;
          border: 1px solid #ffffff33;
          background: transparent;
          height: 40px;
          color: #e6e8ea;
        }
        .inp-name {
          width: 120px;
        }
        .inp-phone {
          width: 214px;
        }
        .id-number {
          width: 100%;
        }
        .enroll {
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
          color: #fff;
          span {
            margin-top: 14px;
            line-height: 16px;
            font-size: 15px;
          }
          .btn {
            width: 140px;
            height: 40px;
            line-height: 40px;
            background: #169bd5;
            font-size: 17px;
            text-align: center;
            cursor: pointer;
          }
        }
      }
      .open-time {
        width: 310px;
        text-align: center;
        padding-top: 15px;
        h5 {
          margin: 45px 0 28px;
          line-height: 26px;
          font-size: 26px;
          color: #fff;
        }
        p {
          margin: 0;
          line-height: 29px;
          font-size: 13px;
          color: #c1c6cb;
        }
      }
    }
  }
  section {
    width: 1240px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    background: #fff;
    article {
      width: 924px;
      padding-top: 55px;
      h4 {
        margin: 0;
        line-height: 26px;
        font-size: 26px;
        color: #333;
        text-align: center;
      }
      span {
        display: block;
        margin: 13px 0 90px;
        line-height: 13px;
        font-size: 13px;
        color: #333;
        text-align: center;
      }
      p {
        line-height: 24px;
        color: #333;
        font-size: 15px;
        margin-bottom: 25px;
      }
      img {
        margin: 20px 0 50px;
      }
      .article-time {
        padding: 21px 0 55px;
        border-top: 1px solid #f2f2f2;
      }
    }
    aside {
      width: 276px;
      h4 {
        margin: 54px 0 19px;
        border-left: 4px solid #333;
        text-indent: 16px;
        font-size: 19px;
        color: #333;
      }
      img {
        width: 276px;
        height: 131px;
        margin-bottom: 6px;
      }
      p {
        line-height: 21px;
        font-size: 15px;
        color: #333;
        word-break: break-all;
        margin-bottom: 71px;
      }
    }
  }
  .recommendation-list {
    margin: 0 auto;
    width: 1240px;
    overflow: hidden;
    h4 {
      margin-bottom: 24px;
      border-left: 4px solid #333;
      text-indent: 16px;
      font-size: 19px;
      color: #333;
    }
    .reco-box {
      width: 1320px;
      display: flex;
      justify-content: left;
      flex-wrap: wrap;
      .reco-box-item {
        width: 251px;
        margin-right: 79px;
        img {
          width: 251px;
          height: 179px;
          margin-bottom: 10px;
        }
        p {
          line-height: 21px;
          font-size: 15px;
          color: #333;
          word-break: break-all;
          margin-bottom: 10px;
        }
        span {
          display: block;
          line-height: 16px;
          font-size: 16px;
          color: #da514e;
          margin-bottom: 36px;
        }
      }
    }
  }

  input::-webkit-input-placeholder,
  textarea::-webkit-input-placeholder {
    font-size: 13px;
    color: #e6e8ea;
  }
}
</style>
